<script setup lang="ts">
import {ref} from 'vue'
import {useNotificationsStore} from '../../stores/notifications'
import HotelFilter from './HotelFilter.vue'
import LogoutProfileMenu from './LogoutProfileMenu.vue'
import CompanyButton from './CompanyButton.vue'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

const notificationsStore = useNotificationsStore()
const isNewUiEnabled = useNewUiEnabled()

let toggleTimeoutId: number | undefined = undefined
const showDialog = ref(false)

function onMouseEnter() {
  notificationsStore.showSidePanel = false
  toggleTimeoutId = window.setTimeout(() => {
    setTimeout(() => {
      toggleTimeoutId = undefined
    }, 500)

    showDialog.value = true
  }, 200)
}

function onMouseLeave() {
  window.clearTimeout(toggleTimeoutId)
  toggleTimeoutId = undefined

  showDialog.value = false
}

function toggleHandler() {
  if (showDialog.value && toggleTimeoutId != null) return
  showDialog.value = !showDialog.value
}
</script>

<template>
  <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <CompanyButton class="h-20 max-w-[350px]" @click="toggleHandler"></CompanyButton>

    <transition
      enter-active-class="duration-75 ease-in-out"
      enter-from-class="-translate-y-1/4 scale-y-0 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="duration-75 ease-in-out"
      leave-from-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="-translate-y-1/4 scale-y-0 opacity-0"
    >
      <template v-if="showDialog">
        <div
          class="absolute w-72 flex flex-col gap-y-5 p-5 text-base z-header"
          :class="
            isNewUiEnabled
              ? 'right-8 rounded-b-lg bg-white text-new-neutral-700 shadow-[0px_0px_3px_0px_#00000033]'
              : 'right-0 bg-white shadow-md'
          "
        >
          <LogoutProfileMenu></LogoutProfileMenu>
          <hr class="w-full border-t" :class="isNewUiEnabled ? 'border-new-neutral-300' : 'border-gray-300'" />
          <HotelFilter></HotelFilter>
        </div>
      </template>
    </transition>
  </div>
</template>
